"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'account.upgrade.title': 'Aggiornamento Account',
    'account.upgrade.currentGrade': 'Livello Account Attuale',
    'account.upgrade.selectGrade': 'Il tuo piano',
    'account.upgrade.save': 'Salva Modifiche',
    'account.upgrade.payNow': 'Paga Ora e Aggiorna',
    'account.upgrade.downgrade': 'Passa a Piano Inferiore',
    'account.upgrade.mostPopular': 'Più Popolare',
    'account.upgrade.selectPlan': 'Seleziona Piano',
    'account.upgrade.selected': 'Selezionato',
    'account.upgrade.success': 'Livello account aggiornato con successo',
    'account.upgrade.paymentInitiated': 'Pagamento avviato. Si prega di completare il pagamento per aggiornare il proprio account.',
    'account.upgrade.errors.general': 'Impossibile aggiornare il livello account',
    'account.upgrade.errors.loadUser': 'Impossibile caricare le informazioni utente',
    'account.upgrade.errors.noUser': 'Utente non trovato',
    'account.upgrade.credits': 'crediti',
    'account.upgrade.noCredits': 'Nessun credito incluso',
    'account.upgrade.perMonth': 'al mese',
    'account.upgrade.changePlan': 'Cambia Piano',
    'account.upgrade.currentPlan': 'Piano Attuale',
    'account.upgrade.futureGradeInfo': 'Questo piano sarà attivato il',
    'account.upgrade.confirm.title': 'Conferma Cambio Piano',
    'account.upgrade.confirm.downgrade': 'Sei sicuro di voler eseguire il downgrade al piano gratuito? Perderai l\'accesso alle funzionalità premium.',
    'account.upgrade.confirm.change': 'Sei sicuro di voler cambiare il tuo piano a',
    'account.upgrade.success.changed': 'Il tuo piano è stato cambiato con successo',
    'account.upgrade.success.upgraded': 'Account aggiornato con successo!',
    'account.upgrade.errors.changeFailed': 'Impossibile cambiare il tuo piano',
    'account.upgrade.errors.paymentFailed': 'Pagamento fallito. Per favore riprova.',
    'account.upgrade.monthly': 'Mensile',
    'account.upgrade.yearly': 'Annuale',
    'account.upgrade.saveMore': 'Risparmia Di Più',
    'account.upgrade.discount': 'SCONTO',
    'account.upgrade.save_money_amount': 'Risparmia',
};
